/* From Victory — global behaviors.
   Minimal vanilla JS: header scroll state, mobile menu, disclosures,
   reveal-on-scroll. No libraries. */

(function () {
  'use strict';

  var REDUCED_MOTION = window.matchMedia('(prefers-reduced-motion: reduce)');

  /* ---- Focus trap ----------------------------------------- */

  var FOCUSABLE =
    'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  function trapFocus(container, event) {
    var focusable = Array.prototype.filter.call(
      container.querySelectorAll(FOCUSABLE),
      function (el) {
        return el.offsetParent !== null || el === document.activeElement;
      }
    );
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  /* ---- Header: solid-on-scroll ------------------------------ */

  function initHeader() {
    var header = document.querySelector('[data-header]');
    if (!header) return;

    var setState = function () {
      header.classList.toggle('is-scrolled', window.scrollY > 24);
    };
    setState();
    window.addEventListener('scroll', setState, { passive: true });

    // Expose real header + announcement heights for anchored layouts
    // and the transparent-over-hero fixed position.
    var announcement = document.querySelector('.announcement-bar');
    var setHeight = function () {
      document.documentElement.style.setProperty(
        '--header-height',
        header.offsetHeight + 'px'
      );
      document.documentElement.style.setProperty(
        '--announcement-height',
        (announcement ? announcement.offsetHeight : 0) + 'px'
      );
    };
    setHeight();
    window.addEventListener('resize', setHeight);
  }

  /* ---- Mobile menu drawer ---------------------------------- */

  function initMenuDrawer() {
    var toggle = document.querySelector('[data-menu-toggle]');
    var drawer = document.querySelector('[data-menu-drawer]');
    if (!toggle || !drawer) return;

    var lastFocused = null;

    function open() {
      lastFocused = document.activeElement;
      drawer.hidden = false;
      toggle.setAttribute('aria-expanded', 'true');
      document.body.classList.add('menu-open');
      requestAnimationFrame(function () {
        drawer.classList.add('is-open');
        var firstLink = drawer.querySelector(FOCUSABLE);
        if (firstLink) firstLink.focus();
      });
    }

    function close() {
      drawer.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('menu-open');
      var done = function () {
        drawer.hidden = true;
        drawer.removeEventListener('transitionend', done);
        clearTimeout(fallback);
      };
      if (REDUCED_MOTION.matches) {
        drawer.hidden = true;
      } else {
        /* fallback in case the transition never fires */
        var fallback = setTimeout(done, 400);
        drawer.addEventListener('transitionend', done);
      }
      if (lastFocused) lastFocused.focus();
    }

    toggle.addEventListener('click', function () {
      var expanded = toggle.getAttribute('aria-expanded') === 'true';
      expanded ? close() : open();
    });

    drawer.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        event.stopPropagation();
        close();
      } else if (event.key === 'Tab') {
        trapFocus(drawer, event);
      }
    });

    drawer.querySelectorAll('[data-menu-close]').forEach(function (el) {
      el.addEventListener('click', close);
    });
  }

  /* ---- Accessible dropdown disclosures (desktop nav) -------- */

  function initDisclosures() {
    document.querySelectorAll('details[data-disclosure]').forEach(function (details) {
      var summary = details.querySelector('summary');

      details.addEventListener('keyup', function (event) {
        if (event.key === 'Escape' && details.open) {
          details.open = false;
          summary.focus();
        }
      });

      details.addEventListener('focusout', function (event) {
        if (!details.contains(event.relatedTarget)) details.open = false;
      });

      document.addEventListener('click', function (event) {
        if (details.open && !details.contains(event.target)) details.open = false;
      });
    });
  }

  /* ---- Reveal on scroll ------------------------------------- */

  function initReveal() {
    var items = document.querySelectorAll('.reveal');
    if (!items.length) return;

    if (
      REDUCED_MOTION.matches ||
      document.body.classList.contains('no-animations') ||
      !('IntersectionObserver' in window)
    ) {
      items.forEach(function (el) {
        el.classList.add('is-revealed');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-revealed');
            observer.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.05 }
    );

    items.forEach(function (el) {
      observer.observe(el);
    });
  }

  /* ---- Init ------------------------------------------------- */

  function init() {
    initHeader();
    initMenuDrawer();
    initDisclosures();
    initReveal();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
